import React from 'react';
import { useSelector } from 'react-redux';

import { userSelectors } from 'reducers';
import { ucFirst } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import { DataTile } from 'components';
import InvestorPasswordForm from './InvestorPasswordForm';
import InvestorEmailList from './InvestorEmailList';
import PageWrapper from './PageWrapper';
import CoSubscriberForm from 'containers/tunnel/steps/co-subscriber/CoSubscriberForm';
import ContactInfoPage from 'containers/tunnel/steps/contact-info/ContactInfoPage';
import { Grid, Typography } from '@mui/material';

const dataFormSx = { padding: '30px', flexDirection: 'column' };

const InvestorAccount = () => {
    const internalUser = useSelector(userSelectors.getInternalUser);
    const currentSubscription = useSelector(userSelectors.getCurrentSubscription);

    return (
        <PageWrapper
            title={
                <React.Fragment>
                    {texts.BONJOUR} {ucFirst(internalUser.firstName)},<br></br>
                    {texts.BIENVENUE_ESPACE_PERSONNEL}
                </React.Fragment>
            }
        >
            <DataTile title={texts.MY_INFOS} sx={dataFormSx}>
                <Grid container spacing={5} justifyContent="space-around">
                    <Grid
                        item
                        sx={theme => ({
                            flex: '0 1 50%',
                            [theme.breakpoints.down('md')]: {
                                flex: '0 1 100%',
                            },
                        })}
                    >
                        <Typography
                            align="center"
                            gutterBottom
                            sx={{ fontSize: '18px', marginBottom: '20px' }}
                        >
                            {texts.SUBSCRIBER}
                        </Typography>
                        <ContactInfoPage
                            isResubmit
                            hasStatusOk
                            isStepVerified
                            isPhoneVerified
                            isOnClientSpace
                        />
                    </Grid>
                    {currentSubscription?.withCoSubscriber && (
                        <Grid
                            item
                            sx={theme => ({
                                flex: '0 1 50%',
                                height: '100%',
                                [theme.breakpoints.down('md')]: {
                                    flex: '0 1 100%',
                                },
                            })}
                        >
                            <Typography
                                align="center"
                                gutterBottom
                                sx={{ fontSize: '18px', marginBottom: '20px' }}
                            >
                                {texts.CO_SUBSCRIBER}
                            </Typography>
                            <CoSubscriberForm
                                isOnClientSpace
                                isResubmit
                                isStepVerified
                                isPhoneVerified
                                hasStatusOk
                            />
                        </Grid>
                    )}
                </Grid>
            </DataTile>
            <DataTile title={texts.COMMUNICATIONS} sx={dataFormSx}>
                <InvestorEmailList
                    emailsKey="reportingCCEmails"
                    title={texts.REPORTING_INVESTOR_EMAILS}
                />
                <InvestorEmailList
                    emailsKey="fundraisingCCEmails"
                    title={texts.FUND_CALL_AND_DISTRIBUTION_INVESTOR_EMAILS}
                />
                <InvestorEmailList
                    emailsKey="capitalAccountCCEmails"
                    title={texts.CAPITAL_ACCOUNTS_INVESTOR_EMAILS}
                />
                <InvestorEmailList
                    emailsKey="subscriptionProcessCCEmails"
                    title={texts.SUBSCRIPTION_PROGRESS_INVESTOR_EMAILS}
                />
            </DataTile>
            <DataTile title={texts.PASSWORD_CHANGE} sx={dataFormSx}>
                <InvestorPasswordForm />
            </DataTile>
        </PageWrapper>
    );
};

export default InvestorAccount;
